import React, { ComponentProps, Suspense, useMemo } from 'react'
import { iconMap } from './iconMap'
type Web3IconProps = ComponentProps<(typeof iconMap)['ETH']>

type LazyLoadingIconProps = Web3IconProps & {
  symbol: string
  fallback?: React.ReactNode
}

export const LazyIcon = ({ symbol, fallback, ...props }: LazyLoadingIconProps) => {
  const IconComponent = iconMap[symbol] || iconMap[symbol.toUpperCase()]

  const renderedIcon = useMemo(() => {
    if (!IconComponent) {
      return <>{fallback}</>
    }
    return <IconComponent variant={'mono'} {...props} />
  }, [IconComponent, props, fallback])

  return <Suspense fallback={fallback}>{renderedIcon}</Suspense>
}
